import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import AddTestMutation from './AddTestMeasurementMutation';
import TestsQuery from '../Fetch/TestsQuery';

const AddTestMeasurementConnectorApollo = ({ children }) => {
  const [addTest, { data, loading, error }] = useMutation(AddTestMutation);

  const createAddTestMeasurement = async (request) => {
    const response = await addTest({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TestsQuery,
        },
        {
          query: TestsQuery,
          variables: { filter: 'TSH' },
        },
        {
          query: TestsQuery,
          variables: { filter: 'FT3' },
        },
        {
          query: TestsQuery,
          variables: { filter: 'FT4' },
        },
        {
          query: TestsQuery,
          variables: { filter: 'ANTI_TG' },
        },
        {
          query: TestsQuery,
          variables: { filter: 'ANTI_TPO' },
        },
      ],
    });

    return response;
  };

  return children({
    addTestMeasurement: {
      addTest: createAddTestMeasurement,
      response: data,
      loading,
      error,
    },
  });
};

AddTestMeasurementConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AddTestMeasurementConnectorApollo;
